// Fish (M18-adjacent). PURE (ENG-1). The small water mobs that can be scooped into
// a water bucket and released again: the fish ↔ bucket-item mapping the host uses
// when a player right-clicks a fish with a water bucket, or places a fish bucket.

const FISH = new Set(['cod', 'salmon', 'tropical_fish', 'pufferfish']);

/** Whether a mob is a fish that a water bucket can scoop. */
export function isBucketableFish(type: string): boolean {
  return FISH.has(type);
}

/** The bucket item a scooped fish becomes (`cod` → `cod_bucket`), or null. */
export function fishBucket(type: string): string | null {
  return FISH.has(type) ? `${type}_bucket` : null;
}

/** The fish released from a bucket item (`cod_bucket` → `cod`), or null if the item
 *  is not a fish bucket. */
export function fishFromBucket(bucketItem: string): string | null {
  if (!bucketItem.endsWith('_bucket')) return null;
  const fish = bucketItem.slice(0, -'_bucket'.length);
  return FISH.has(fish) ? fish : null;
}
